<template>
    <div>
        <div class="slider-bar">
            <div class="list" @click="contact">
                <img src="../../assets/pc/icons/contact.png" alt="">
                <div class="item">Contact Us</div>
            </div>
            <div class="list" @click="phone">
                <img src="../../assets/pc/icons/phone2.png" alt="">
                <div class="item">2969-3116</div>
            </div>
            <div class="list" @click="gotoChat">
                <img src="../../assets/pc/icons/chat.png" alt="">
                <div class="item">Click to chat</div>
            </div>
            <div class="list" v-show="showBackTop" @click="backToTop">
                <img src="../../assets/pc/icons/arrow-up.png" alt="">
            </div>
        </div>
        <ContactUs :show="showContactUs" @close="closeContact"></ContactUs>
    </div>
</template>
<script>
import ContactUs from "../common/ContactUs.vue";
export default {
    name: 'SliderBar',
    components: {
        ContactUs
    },
    data() {
        return {
            showBackTop: false,
            showContactUs: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        contact() {
            this.$gioAction('navrightclick_hk', { 'jingtaititle_hk': 'Contact Us' });
            this.showContactUs = true;
        },
        phone() {
            this.$gioAction('navrightclick_hk', { 'jingtaititle_hk': 'Call sales' });
            window.location.href = 'tel:2969-3116';
        },
        gotoChat() {
            this.$gioAction('navrightclick_hk', { 'jingtaititle_hk': 'Chat' });
            window.open('https://www.facebook.com/messages/t/DellEMCHK', '_blank')
        },
        handleScroll() {
            this.showBackTop = window.scrollY > 100
        },
        backToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        closeContact() {
            this.showContactUs = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.slider-bar {
    position: fixed;
    right: 0;
    top: 100%;
    transform: translateY(-262px);
    z-index: 98;
    display: block;
    left: inherit;
    bottom: inherit;

    .list {
        width: 50px;
        height: 50px;
        background: #0076CE;
        margin-bottom: 4px;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        overflow: hidden;

        img {
            display: block;
            width: 50%;
            height: auto;
        }

        .item {
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            width: 130px;
            line-height: 50px;
            text-align: center;
            transition: all ease .3s;
            z-index: -2;
            color: #fff;
            background: #00447c;
            border-radius: 6px 0 0 6px;
        }

        &:hover {
            background: #00447C;
            border-radius: 0 6px 6px 0;
            overflow: visible;
            &:last-child {
                border-radius: 6px;
            }
            .item {
                left: -130px;
            }
        }
    }
}
</style>